var app = angular.module("leonardo");

var ManageInfoDialog = function($scope) {

  $scope.invitation = $scope.ngDialogData.invitation;
  $scope.user_role = parseInt($scope.invitation.management_info.management_account_user_role);

};

app.controller('ManageInfoDialog', ['$scope', ManageInfoDialog]);
